module.exports = __webpack_public_path__ + "static/media/Wearconrete_4_up and at em bra.4b164874.jpeg";